import React from 'react'
import './Card.css'

export default class Card extends React.Component {
  static defaultProps = {
    items: [],
    className: ''
  }

  render() {
    const { items, className } = this.props

    return (
      <div className={`cards ${className}`}>
        {!!items &&
          items.map((item, index) => (
            <a href={item.canonicalLink} className="card">
              <img src={item.featuredImage} alt={item.title || ''} className="card__image" />
            </a>
          ))}
      </div>
    )
  }
}
